import Game from "@/components/views/Game";
import store from "@/store";

import rounds from "@/router/rounds.routes";
import shop from "@/router/shop.routes";
import spin from "@/router/spin.routes";

export default [
	{
		path: "/game",
		component: Game,
		children: [
			...rounds,
			...shop,
			...spin,
			{
				path: "/game/start",
				beforeEnter(to, from, next) {
					store.dispatch("game/start");
					next({ path: "/game/rounds/begin" });
				},
			},
			{
				path: "/game/complete",
				beforeEnter(to, from, next) {
					store.dispatch("game/end");
					store.dispatch("global/analytics/trackEndgameEvents");
					next({ path: "/gameover" });
				},
			},
		],
	},
];
